import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9996 12.7069L5.65287 19.0535C5.4576 19.2488 5.14102 19.2488 4.94576 19.0535C4.7505 18.8583 4.7505 18.5417 4.94577 18.3464L11.2925 11.9998L4.94644 5.65355C4.75118 5.45829 4.75118 5.1417 4.94644 4.94644C5.1417 4.75118 5.45829 4.75118 5.65355 4.94645L11.9997 11.2927L18.346 4.94643C18.5412 4.75117 18.8578 4.75117 19.0531 4.94643C19.2483 5.1417 19.2483 5.45828 19.0531 5.65354L12.7068 11.9998L19.0526 18.3457C19.2478 18.5409 19.2478 18.8575 19.0526 19.0528C18.8573 19.248 18.5407 19.248 18.3455 19.0528L11.9996 12.7069Z"
});
var roundLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9996 12.7069L5.65287 19.0535C5.4576 19.2488 5.14102 19.2488 4.94576 19.0535C4.7505 18.8583 4.7505 18.5417 4.94577 18.3464L11.2925 11.9998L4.94644 5.65355C4.75118 5.45829 4.75118 5.1417 4.94644 4.94644C5.1417 4.75118 5.45829 4.75118 5.65355 4.94645L11.9997 11.2927L18.346 4.94643C18.5412 4.75117 18.8578 4.75117 19.0531 4.94643C19.2483 5.1417 19.2483 5.45828 19.0531 5.65354L12.7068 11.9998L19.0526 18.3457C19.2478 18.5409 19.2478 18.8575 19.0526 19.0528C18.8573 19.248 18.5407 19.248 18.3455 19.0528L11.9996 12.7069Z"
});
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.65294 19.0535L5.29939 19.4071L4.59229 18.7L4.94584 18.3464L11.2926 11.9998L4.94651 5.65357L4.59296 5.30001L5.30007 4.59291L5.65361 4.94647L11.9997 11.2927L18.346 4.94645L18.6996 4.5929L19.4067 5.30001L19.0531 5.65356L12.7068 11.9998L19.0527 18.3457L19.4062 18.6992L18.6991 19.4063L18.3455 19.0528L11.9997 12.7069L5.65294 19.0535Z"
});
var sharpLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.65294 19.0535L5.29939 19.4071L4.59229 18.7L4.94584 18.3464L11.2926 11.9998L4.94651 5.65357L4.59296 5.30001L5.30007 4.59291L5.65361 4.94647L11.9997 11.2927L18.346 4.94645L18.6996 4.5929L19.4067 5.30001L19.0531 5.65356L12.7068 11.9998L19.0527 18.3457L19.4062 18.6992L18.6991 19.4063L18.3455 19.0528L11.9997 12.7069L5.65294 19.0535Z"
});
var IconX = makeIcon('IconX', 'X', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconX;